export const WALLET_CONNECTED = "Wallet connected!"
export const WENT_WRONG = "Something went wrong!"
export const CONNECT_WALLET = "Connect yout wallet!"
export const TOKEN_FETCH_ERROR = "Error fetching token!"